module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_8_2.03242160.jpg";